const setTokenAndResizeScreen = (
  $rootScope,
  appAPI,
  appEvents,
  appResizableScreen,
  appSession,
  APP_EVENTS,
) => {
  'ngInject';

  const update = () => {
    const { token } = appSession.getSession();
    appAPI.setAuthorizationToken(token);
    appResizableScreen.update();
  };

  const subscriptions = [
    appEvents.on(APP_EVENTS.start, () => appSession.load()),
    appSession.onSessionLoaded(update),
    appSession.onSessionCreated(update),
  ];

  $rootScope.$on('$destroy', () => {
    subscriptions.forEach((unsubscribeFn) => unsubscribeFn());
  });
};

export default setTokenAndResizeScreen;
